import { ComponentConfigType } from '../../utils/data-parser';
import { ComponentType, type IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.FormDatePicker,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'disabled',
          label: 'Disabled',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'placeholder',
          label: 'Placeholder',
          valueComponent: {
            type: 'Input',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
            {
              key: ComponentConfigType.Translate,
              value: BASIC_TANSLATE_TOOLTIP,
            },
          ],
        },
        {
          name: 'allowClear',
          label: 'Allow Clear',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'picker',
          label: 'Picker Type',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Date', value: 'date' },
              { label: 'Week', value: 'week' },
              { label: 'Month', value: 'month' },
              { label: 'Quarter', value: 'quarter' },
              { label: 'Year', value: 'year' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'format',
          label: 'Format',
          valueComponent: {
            type: 'Input',
            placeholder: 'YYYY-MM-DD',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'showTime',
          label: 'Show Time',
          valueComponent: {
            type: 'Switch',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'size',
          label: 'Size',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Large', value: 'large' },
              { label: 'Middle', value: 'middle' },
              { label: 'Small', value: 'small' },
            ],
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
  ],
};
